import { createFileRoute } from "@tanstack/react-router";
import { useAppTranslation } from "@/hooks/use-app-translation";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/lifecycles/$lifecycleId/rules",
)({
	component: LifecycleRulesTabContent,
});

function LifecycleRulesTabContent() {
	const { t } = useAppTranslation();

	return (
		<div className="space-y-4 px-5 pb-5">
			<div>
				<h3 className="text-lg font-semibold text-[16px] text-primary">
					{t("admin.lifecycles.drawer.rules.title")}
				</h3>
				<p className="text-sm text-gray-500">
					{t("admin.lifecycles.drawer.rules.description")}
				</p>
			</div>
			<div className="rounded-lg border border-gray-200 bg-gray-50 p-6">
				<p className="text-sm text-gray-500">
					{t("admin.lifecycles.drawer.rules.empty")}
				</p>
			</div>
		</div>
	);
}
